import React from 'react';
import { observer } from 'mobx-react';
import GridSectionHeader from '../gridSectionHeader/GridSectionHeader';
var StickyGridSectionHeader = function (_a) {
    var stickyGridSectionHeaderMetadata = _a.stickyGridSectionHeaderMetadata, sections = _a.sections, sectionHeaderTheme = _a.sectionHeaderTheme;
    if (stickyGridSectionHeaderMetadata.stickySectionIndex === undefined) {
        console.log('stickyGridSectionHeaderMetadata.stickySectionIndex UNDEFINED');
        return null;
    }
    var section = sections[stickyGridSectionHeaderMetadata.stickySectionIndex];
    if (!section) {
        return null;
    }
    return (React.createElement(GridSectionHeader, { section: section, sectionHeaderTheme: sectionHeaderTheme }));
};
export default observer(StickyGridSectionHeader);
//# sourceMappingURL=StickyGridSectionHeader.js.map